import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

const Gifts = () => {
  return (
    <>
    <Navbar/>
    
    <div>
      Gifts your
    </div>
    <Footer/>
    </>
  )
}

export default Gifts
